import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initialState";
import service from "../utils/services/subsidiary";

export const subsidiarySlice = createSlice({
  name: "subsidiaries",
  initialState: initialState.subsidiaries,
  reducers: {
    receive: (state, action) => {
      const newList = [];
      state.splice(0, state.length);
      if (action.payload && action.payload.length > 0)
        newList.push(...action.payload);
      state.push(...newList);
    },
  },
});

export const { receive } = subsidiarySlice.actions;

export const getAll = async (CompanyId, dispatch) => {

  if (typeof dispatch !== 'function') {
    console.error("🚨 CRITICAL ERROR: 'getAll' from subsidiarySlice was called without dispatch!");
    console.error("Called with args:", { CompanyId, dispatch });
    // This trace will tell you exactly which file called 'getAll' from subsidiarySlice incorrectly
    console.trace(); 
    return;
  }

  await service.getByIdCompany(CompanyId).then((res) => {
    dispatch(receive(res ?? []));
    return res;
  });
}
export const selectSubsidiaries = (state) => {
  return state?.subsidiaries ?? [];
};

export default subsidiarySlice.reducer;
